import React from 'react'

/**
 * GasCan icon - Custom SVG component matching Phosphor icon style
 * Based on Phosphor Icons v2.0+ GasCan icon
 */
const GasCanIcon = ({ size = 24, weight = 'regular', color = 'currentColor', ...props }) => {
  const strokeWidth = weight === 'fill' ? 0 : 16
  const fillColor = weight === 'fill' ? color : 'none'
  const strokeColor = weight === 'fill' ? 'none' : color

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="256" height="256" fill="none"/>
      <path
        d="M123.31,32H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V107.31a8,8,0,0,1,2.34-5.65l67.32-67.32A8,8,0,0,1,123.31,32Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <line
        x1="136"
        y1="64"
        x2="176"
        y2="64"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <line
        x1="80"
        y1="120"
        x2="176"
        y2="192"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <line
        x1="176"
        y1="120"
        x2="80"
        y2="192"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M66.34,85.66l-16-16a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,0l16,16"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default GasCanIcon
